<template>
  <div>
    <el-popover
      placement="bottom-end"
      width="550"
      trigger="hover"
      @show="handleShow"
    >
      <el-row :gutter="10">
        <el-col :span="24" style="margin-bottom: 8px;">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        </el-col>
        <el-checkbox-group v-model="checkedArr" @change="handleCheckedArrChange">
          <el-col v-for="columns in checkColumns" :key="columns.prop" :span="6" style="margin-bottom: 8px;">
            <el-checkbox :label="columns.prop" :disabled="columns.disabled">
              {{columns.label}}
            </el-checkbox>
          </el-col>
        </el-checkbox-group>
      </el-row>
      <div style="text-align: right; margin: 0">
        <el-button type="primary" size="mini" @click="handleConfirm()" :loading="loading">保存</el-button>
        <el-button @click="handleReset()" size="mini">重置</el-button>
      </div>
      <div slot="reference" style="font-size: 26px;">
        <icon-svg name="icon-screening" />
      </div>
    </el-popover>

  </div>
</template>

<script>
import { setTabelColums, getTabelColums } from '@/utils/table';

export default {
  props: {
    columnsKey: {
      type: String,
      required: true,
    },
    // 关联表头
    tableColumn: {
      type: Array,
      default: () => ([]),
    },
    // 推荐字段表头
    recommendedColumn: {
      type: Array,
      default: () => ([]),
    },
    // 显示的表头数据
    selectTableColumn: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      checkedArr: [], // 选中的数据
      isIndeterminate: true, // checkbox 的不确定状态
      checkAll: false, // 是否全选
      loading: false,
    };
  },
  computed: {
    checkColumns() {
      const tableColumn = this.getShowColumn(this.tableColumn);
      const isOperateCur = tableColumn.filter((it) => it.prop === 'operate');
      const arr = tableColumn.filter((it) => it.prop !== 'operate');
      return [...arr, ...this.recommendedColumn, ...(isOperateCur || [])];
    },
  },
  methods: {
    init(isReset = false) {
      let list = this.getShowColumn(this.selectTableColumn);
      if (isReset) {
        list = this.tableColumn;
      }
      const propList = list.map((it) => it.prop);
      this.checkedArr = propList;
      this.handleCheckedArrChange(propList);
    },
    getShowColumn(arr = []) {
      return arr.filter((item) => item.isShow === undefined || (typeof item.isShow === 'function' && item.isShow()));
    },
    // 显示触发
    handleShow() {
      this.$nextTick(() => {
        this.init();
      });
    },
    // 重置
    handleReset() {
      this.init(true);
    },
    // 保存
    async handleConfirm() {
      // 保持原有显示字段顺序
      const list = [];
      this.checkColumns.forEach((column) => {
        this.checkedArr.forEach((item) => {
          if (column.prop === item) {
            list.push(column);
          }
        });
      });
      // 请求接口保存该用户配置
      try {
        this.loading = true;
        const setList = list.map((item) => ({ label: item.label, prop: item.prop }));
        await this.$store.dispatch('dictionary/setUserTemplate', {
          pageKey: this.columnsKey,
          template: JSON.stringify(setList),
        });
        const selectTableColumn = getTabelColums({ data: list, list: [...this.tableColumn, ...this.recommendedColumn] });
        this.$emit('confirm', selectTableColumn);
        setTabelColums({ list: setList, columnsKey: this.columnsKey });
        // 已经存在的key更新vuex内容
        const { userTemplate = {} } = this.$store.state.dictionary;
        if (userTemplate[this.columnsKey]) {
          this.$store.commit('dictionary/SET_USER_TEMPLATE', { data: selectTableColumn, key: this.columnsKey });
        }
        this.$message.success('保存成功');
        this.loading = false;
      } catch (error) {
        this.$message.error('保存失败');
        this.loading = false;
      }
    },
    // 全选
    handleCheckAllChange(val) {
      const allArr = this.checkColumns.map((it) => it.prop);
      const disableArr = [];
      this.checkColumns.forEach((item) => {
        if (item.disabled) {
          disableArr.push(item.prop);
        }
      });
      this.checkedArr = val ? allArr : disableArr;
      const checkedCount = this.checkedArr.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkColumns.length;
    },
    // 单个选项
    handleCheckedArrChange(values) {
      const checkedCount = values.length;
      this.checkAll = checkedCount === this.checkColumns.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkColumns.length;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-checkbox {
    display: flex;
    align-items: center;
    .el-checkbox__label {
      white-space: pre-wrap;
    }
  }
}
</style>
